<template lang="pug">
#Footer
    p The Department of Education’s <a href="https://www.education.vic.gov.au/Pages/disclaimer.aspx">Disclaimer</a>, <a href="https://www.education.vic.gov.au/Pages/webprivacypolicy.aspx">Privacy</a> and <a href="https://www.education.vic.gov.au/Pages/copyright.aspx" id="copyright-link">Copyright</a> applies to information on this website.
</template>

<script>
export default {
    name: 'Footer',
    data: () => ({}),
    created() {
        window.Footer = this;
    },
};
</script>

<style scoped>
.logo {
    position: relative;
    height: 40px;
    margin: 0 50px 0 0;
}
#Footer {
    padding: 0 0.5em;
    text-align: center;
}

#Footer p {
    margin: 0.25em;
}
</style>
